import type { UfsPraticadasDto, UfsPraticadasResponse } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Chaves invalidadas ao salvar as UFs: a liberacao por UF (precificacao) e o rascunho dependem delas. */
const INVALIDAR = [['tabelas-preco'], ['precificacao'], ['rascunho']];

/** GET /tabelas-preco/:id/ufs-praticadas: efetivas, sugeridas (origem/clientes), salvas (null = nunca editada) e UF de origem. */
export function useUfsPraticadas(tabelaId: string | null) {
  return useConsulta<UfsPraticadasResponse>(['tabelas-preco', tabelaId, 'ufs-praticadas'], `/tabelas-preco/${tabelaId ?? ''}/ufs-praticadas`, {
    ativo: tabelaId !== null,
  });
}

/** PUT /tabelas-preco/:id/ufs-praticadas (`tabela.editar`): substitui a lista de UFs praticadas da tabela. */
export function useSalvarUfsPraticadas(tabelaId: string) {
  return useMutacao<UfsPraticadasResponse, UfsPraticadasDto>({
    metodo: 'PUT',
    caminho: () => `/tabelas-preco/${tabelaId}/ufs-praticadas`,
    corpo: (v) => v,
    invalidar: INVALIDAR,
  });
}
